import axios from "axios";
import { configs } from "../../../assets/Config";
import FormData from 'form-data';

// get all bonds list
export function getAllBonds(token, getDeleted) {
    return new Promise(async (resolve, reject) => {
        try {
            let url = 'bond'
            if (getDeleted) {
                url = '/bond/deleted'
            }

            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/${url}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// get bond data by id
export function getBondById(token, bondId) {
    return new Promise(async (resolve, reject) => {
        try {

            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/bond/${bondId}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// create or update bond
export function createUpdateBond(token, name, isin, rate_of_return, maturity_period, rating, disabletrading, description, snapshot, key_investment_highlights, deal_structure, deal_terms, faqs, documents, key_1, value_1, key_2, value_2, logo, editBond, bondId) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = new FormData();
            data.append("name", name)
            data.append("isin", isin)
            data.append("rate_of_return", rate_of_return)
            data.append("maturity_period", maturity_period)
            data.append("rating", rating)
            data.append("disabletrading", disabletrading)
            data.append("description", description)
            data.append("snapshot", snapshot)
            data.append("key_investment_highlights", key_investment_highlights)
            data.append("deal_structure", deal_structure)
            data.append("deal_terms", deal_terms)
            data.append("faqs", faqs)
            data.append("documents", documents)
            data.append("key_1", key_1)
            data.append("value_1", value_1)
            data.append("key_2", key_2)
            data.append("value_2", value_2)
            data.append("logo", logo)

            let urlE = 'create'

            if (editBond) {
                urlE = 'update'
                data.append('bond_id', bondId)
            }

            var config = {
                method: 'POST',
                url: `${process.env.REACT_APP_BASEURL}/admin/bond/${urlE}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}



// delete company
export function deleteBond(token, bondId) {
    return new Promise(async (resolve, reject) => {
        try {

            var data = {
                company_id: bondId
            }
            var config = {
                method: 'DELETE',
                url: `${process.env.REACT_APP_BASEURL}/admin/bond/delete`,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// restore company
export function restoreBond(token, bondId) {
    return new Promise(async (resolve, reject) => {
        try {

            var data = {
                company_id: bondId
            }
            var config = {
                method: 'PATCH',
                url: `${process.env.REACT_APP_BASEURL}/admin/bond/restore`,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}